module.exports = __webpack_public_path__ + "08f3b7d670fcd7eeb9c165d6b083c04a.pdf";